var Handlebars = require("../../../time.thomasjacob.de/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<h2><span class=\"js_dialog-icon\"></span><span class=\"js_dialog-headline\"></span></h2>\n";
},"useData":true});